import React from "react";

import { Genome } from "../../api";
import { GenomesList } from "../pages/genomes";

export function RelatedGenomes({ genome }: { genome: Genome }) {
  return (
    <>
      <h3>Most similar genomes</h3>
      <p>
        The following genomes have the greatest genomic similarity to this one (&ge;95% average
        nucleotide identity):
      </p>
      <GenomesList collectionName={null} relatedGenome={genome} showDisplayAsTreeOption={false} />
    </>
  );
}
